/* Product card colour swatches (snippets/hs-card-variant-picker.liquid): tap a colour to see it. */
(function () {
  if (window.__hsCardPicker) return;
  window.__hsCardPicker = true;
  document.addEventListener('click', function (e) {
    var sw = e.target && e.target.closest && e.target.closest('.hs-cvp__swatch');
    if (!sw) return;
    var picker = sw.closest('[data-hs-cvp]');
    var card = sw.closest('.card-wrapper');
    if (!picker || !card) return;
    // First tap previews the colour; a second tap on the active colour follows the link.
    if (sw.classList.contains('is-active')) return;
    e.preventDefault();
    var color = sw.getAttribute('data-color');
    picker.querySelectorAll('.hs-cvp__swatch').forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    picker.querySelectorAll('.hs-cvp__size').forEach(function (s) { s.hidden = s.getAttribute('data-color') !== color; });
    var src = sw.getAttribute('data-img');
    var img = card.querySelector('.card__media img');
    if (src && img) {
      img.removeAttribute('srcset');
      img.src = src;
    }
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('[data-hs-cvp]')) return;
      a.href = sw.getAttribute('href');
    });
  });
})();
